// extracted by mini-css-extract-plugin
export var dividerContainer = "_a2-0";
export var line = "_a2-1";